import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en.json';
import th from './locales/th.json';

const localLang = localStorage.getItem('i18nextLng');

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            th: { translation: th },
        },
        lng: localLang || 'th', // Default language
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false,
        },
    });

// ตั้งค่า html lang ให้ตรงกับภาษาเริ่มต้น
const initialLang = localLang || 'th';
if (typeof document !== "undefined") {
  document.documentElement.lang = initialLang;
}

export default i18n;